import { memo, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Drawer from '@/components/layout/Drawer';
import AppHeader from '@/components/layout/AppHeader';
import dashboardMenuItems from '@/utils/dashboardMenuItems';
import { useDashboardContext } from '@/stores/dashboardStore';

function Dashboard() {
  const navigate = useNavigate();
  const location = useLocation();

  const { role } = useDashboardContext();
  const unverifiedPath = (function () {
    if (String(role).toLowerCase() === 'accountant') return 'support';
    else return false;
  })();
  useEffect(() => {
    if (
      location.pathname === '/dashboard/' ||
      location.pathname === '/dashboard'
    ) {
      navigate('all-applications');
    }
  }, []);

  return (
    <div className="h-screen overflow-hidden bg-background">
      <Drawer
        to={false}
        parent={'dashboard'}
        menuItems={dashboardMenuItems()}
        disabledPath={unverifiedPath}
      />
      <AppHeader />
      <main className="lg:ml-[280px] mt-16 h-[calc(100vh-4rem)] overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
}

export default memo(Dashboard);
